// extracted by mini-css-extract-plugin
export var displayNone = "_qw-6";
export var imgContainer = "_qw-2";
export var overflowHidden = "_qw-3";
export var productInfoCardButtonContainer = "_qw-5";
export var productTitleText = "_qw-4";
export var rightArrow = "_qw-1";
export var rightArrowContainer = "_qw-0";